import React from 'react'
import { createRoot } from 'react-dom/client'
import LeftNav from './LeftNav.jsx'

import { addActiveState } from './Helpers/HandleActiveState'
import { returnNavItems } from './Helpers/GetNavLabels.js'
import { handleClick } from './Helpers/HandleNavClick.js'
import { handleScroll } from './Helpers/HandleScroll.js'

class LeftNavElement extends HTMLElement {
  connectedCallback() {
    const navItems = returnNavItems()

    const container = document.getElementById('react-app')
    const root = createRoot(container)

    root.render(<LeftNav navItems={navItems} />)

    // set up a callback to coordinate scrolling between "clicking left nav" vs "using scrollbar"
    let isScrolling = false

    const isScrollingCallback = (setting) => {
      if (typeof setting === 'boolean') {
        isScrolling = setting
      }

      return isScrolling
    }

    // get all the left nav menu items
    const listItems = this.getElementsByTagName('li')

    // set default active nav item
    addActiveState(listItems[0])

    // handle when user clicks left nav
    handleClick(listItems, isScrollingCallback)

    // sync up left nav with scroll position
    handleScroll(navItems, listItems, isScrollingCallback)
  }
}

customElements.define('left-nav', LeftNavElement)
